export const metricsDashboardUrl = "/modules/issue-management/metrics";
export const allIssuesUrl = "/modules/issue-management/all";
export const activeIssuesUrl = "/modules/issue-management/drafts";
export const completedIssuesUrl = "/modules/issue-management/completed";

export const statusDashboardUrl = `${metricsDashboardUrl}/issues-by-status`;
export const createdDateDashboardUrl = `${metricsDashboardUrl}/issues-creation-date`;
export const overdueDashboardUrl = `${metricsDashboardUrl}/overdue-issues`;
export const timeToCloseDashboardUrl = `${metricsDashboardUrl}/time-to-close-issues`;
